import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  TransferDBActions,
  ClearAndFetchAvailableLocationsListing,
  ClearAndFetchAvailableLocationsListingSuccess,
  TransferNoAction,
  ClearAndFetchItemsStoredInLocationDetails,
  ClearAndFetchItemsStoredInLocationDetailsSuccess,
  GetNewLocationDetails,
  GetNewLocationDetailsSuccess,
  ConfirmItemsTransfer,
  ConfirmItemsTransferSuccess,
} from './transfer.actions';
import { catchError, finalize, map, switchMap, take } from 'rxjs/operators';
import { from } from 'rxjs';
import { AppNotificationUtilClass, Organizi8DataProvider } from '@monorepo/services';

@Injectable({
  providedIn: 'root',
})
export class TransferDBEffects {
  constructor(
    private actions$: Actions,
    private apiHelper: AppNotificationUtilClass,
    private organizi8DataProvider: Organizi8DataProvider,
  ) {}

  ClearAndFetchAvailableLocationsListing$ = createEffect(() =>
    this.actions$.pipe(
      ofType<ClearAndFetchAvailableLocationsListing>(TransferDBActions.ClearAndFetchAvailableLocationsListing),
      switchMap((action) =>
        from(this.apiHelper.presentLoading('loading...')).pipe(
          take(1),
          map((loaderEl) => [loaderEl, action.payload] as const),
        ),
      ),
      switchMap(([loaderEl, payload]) =>
        this.organizi8DataProvider.getAvailableLocationsListing(payload).pipe(
          take(1),
          map((res) => new ClearAndFetchAvailableLocationsListingSuccess(res)),
          catchError((error) =>
            from(this.apiHelper.showPopup('Error', 'Something went wrong!')).pipe(
              take(1),
              map(() => {
                console.log('[CLEAR_AND_FETCH_AVAILABLE_LOCATIONS_LISTING_ERROR]', error);
                return new TransferNoAction();
              }),
            ),
          ),
          finalize(() => this.apiHelper.dismissLoadingV2(loaderEl)),
        ),
      ),
    ),
  );

  ClearAndFetchItemsStoredInLocationDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType<ClearAndFetchItemsStoredInLocationDetails>(TransferDBActions.ClearAndFetchItemsStoredInLocationDetails),
      switchMap((action) =>
        from(this.apiHelper.presentLoading('loading...')).pipe(
          take(1),
          map((loaderEl) => [loaderEl, action.payload] as const),
        ),
      ),
      switchMap(([loaderEl, payload]) =>
        this.organizi8DataProvider.getItemsStoredInLocationDetails(payload).pipe(
          take(1),
          map((res) => new ClearAndFetchItemsStoredInLocationDetailsSuccess(res)),
          catchError((error) =>
            from(this.apiHelper.showPopup('Error', 'Something went wrong!')).pipe(
              take(1),
              map(() => {
                console.log('[CLEAR_AND_FETCH_ITEMS_STORED_IN_LOCATION_ERROR]', error);
                return new TransferNoAction();
              }),
            ),
          ),
          finalize(() => this.apiHelper.dismissLoadingV2(loaderEl)),
        ),
      ),
    ),
  );

  GetNewLocationDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType<GetNewLocationDetails>(TransferDBActions.GetNewLocationDetails),
      switchMap((action) =>
        from(this.apiHelper.presentLoading('loading...')).pipe(
          take(1),
          map((loaderEl) => [loaderEl, action.payload] as const),
        ),
      ),
      switchMap(([loaderEl, payload]) =>
        this.organizi8DataProvider.getNewLocationDetails(payload).pipe(
          take(1),
          map((res) => new GetNewLocationDetailsSuccess(res)),
          catchError((error) =>
            from(this.apiHelper.showPopup('Error', 'Something went wrong!')).pipe(
              take(1),
              map(() => {
                console.log('[GET_NEW_LOCATION_DETAILS_ERROR]', error);
                return new TransferNoAction();
              }),
            ),
          ),
          finalize(() => this.apiHelper.dismissLoadingV2(loaderEl)),
        ),
      ),
    ),
  );

  ConfirmItemsTransfer$ = createEffect(() =>
    this.actions$.pipe(
      ofType<ConfirmItemsTransfer>(TransferDBActions.ConfirmItemsTransfer),
      switchMap((action) =>
        from(this.apiHelper.presentLoading('Confirming items transfer request...')).pipe(
          take(1),
          map((loaderEl) => [loaderEl, action.payload] as const),
        ),
      ),
      switchMap(([loaderEl, payload]) =>
        this.organizi8DataProvider.confirmItemsTransfer(payload).pipe(
          take(1),
          map((res) => new ConfirmItemsTransferSuccess(res)),
          catchError((error) =>
            from(this.apiHelper.showPopup('Error', 'Something went wrong!')).pipe(
              take(1),
              map(() => {
                console.log('[CONFIRM_ITEMS_TRANSFER_ERROR]', error);
                return new TransferNoAction();
              }),
            ),
          ),
          finalize(() => this.apiHelper.dismissLoadingV2(loaderEl)),
        ),
      ),
    ),
  );
}
